import {BackgroundAnimationData, BackgroundConstants, CommonConfig, IAdvancedTextConfig, GameConfig, ReelConstants, slotGameConfig} from '@gongxigames/framework/slot';
import './scenes';
import './RichTextStyles';
import {winConfig} from './WinConfig';
import {gameReelsConfig} from 'src/configs/GameReelsConfig';
import {gameAudioConfig} from 'src/configs/GameAudioConfig';
import {buyButtonTXT, buyPopUpTXT, pickBonusTexts} from 'src/configs/LocalizationConfig';
import {freeGamesIntroPopupConfig, freeGamesOutroPopupConfig, retriggerPopupConfig} from 'src/configs/PopupConfig';

export interface GameBackgroundAnimationData extends BackgroundAnimationData {
    spineName: string;
    leftNeonSpineName: string;
    rightNeonSpineName: string;
}

export interface GameCommonConfig extends CommonConfig {
    backgroundAnimation: GameBackgroundAnimationData[];
}

export interface LocalGameConfig extends GameConfig {
    pickBonusTXT?: IAdvancedTextConfig[];
}

const commonConfig = {
    backgroundAnimation: [
        {
            spineName: 'background_base',
            backgroundId: BackgroundConstants.BASE_VIEW,
            animationName: 'base'
        },
        {
            spineName: 'background_fg',
            backgroundId: BackgroundConstants.FREE_SPINS_VIEW,
            animationName: 'freespins'
        }
    ]
};

export const gameConfig: LocalGameConfig = {
    ...slotGameConfig,
    gameName: 'Wolf Haven',
    gamePatch: 'wolfhaven',
    freeSpins: true,
    mathHash: '5be5dcad3cbfd8d3d8730ec4a0a5cb31da14f51e',
    RTP: 96.49,
    detailedRTP: {
        rtpBaseGame: 70.00,
        rtpFeature: 1.83,
        rtpFreeSpins: 24.66,
        rtpTotal: 96.49
    },
    winProbability: '1:1,000,000,000',
    maxMultiplier: '1350',
    winConfig,
    isRubyCoinsGame: true,
    reelsConfig: gameReelsConfig,
    audioConfig: gameAudioConfig,
    commonConfig,
    clientSettings: {
        defaultStake: 0.1,
        stakes: [0.01, 0.02, 0.05, 0.1, 0.25, 0.5, 1, 2.5, 5]
    },
    popupConfig: [
        freeGamesIntroPopupConfig,
        retriggerPopupConfig,
        freeGamesOutroPopupConfig
    ],
    buyButtonTXT,
    buyPopUpTXT,
    pickBonusTXT: pickBonusTexts
};
ReelConstants.SYMBOL = {
    width: 552,
    height: 480
};
